import { mapState } from 'vuex';
import orderList from '../order-grid/OrderList.vue'
import CheckInOrderService from '../../services/orders/CheckInOrderService'
import pendingReasonsService from '../../services/pending-reasons/PendingReasonsService'
import { VMoney } from 'v-money'
import { StorageService } from '../../services/StorageService'
import BarCodeScanner from '../../components/util/BarCodeScanner.vue'
import BarCodePrinter from '../../components/util/BarCodePrinter.vue'
import i18n from '../../i18n/index'
import patientList from '../scheduling/patient-list/PatientList.vue'
import OrderEditionService from '../../services/orders/OrderEditionService'
import { send } from '../../utils/previewPrinter'
import printerPreviewService from '../../services/printer-preview/printerPreviewService'
import serviceOrder from '../../services/orders/OrderService.js'

export default {
  components: {
    orderList,
    BarCodeScanner,
    BarCodePrinter,
    patientList
  },
  data: () => ({
    time: 2000,
    preview: '',
    dialogm1: '',
    dialog: false,
    snackbar: false,
    viewPrint: process.env.VUE_APP_PRINT,
    scaleFeeInvoice: 0,
    patientHeaders: [
      {
        text: i18n.t('headers.document-number'),
        sortable: false,
        value: 'document'
      },
      {
        text: i18n.t('headers.name'),
        sortable: false,
        value: 'fullname'
      },
      {
        text: i18n.t('headers.cellphone'),
        sortable: false,
        value: 'cellPhoneNumber'
      }
    ],
    headers: [
      {
        sortable: false,
        text: i18n.t('headers.order-detail-number'),
        value: 'orderNumber'
      },
      {
        sortable: false,
        text: i18n.t('headers.plu'),
        value: 'plu'
      },
      {
        sortable: false,
        text: i18n.t('headers.description'),
        value: 'medicineDescription'
      },
      {
        sortable: false,
        text: i18n.t('headers.invoice'),
        value: 'invoice'

      },

      {
        sortable: false,
        text: i18n.t('headers.quantity'),
        value: 'count'
      },
      {
        sortable: false,
        text: i18n.t('headers.delivered-quantity'),
        value: 'deliveredCount'
      },
      {
        sortable: false,
        text: i18n.t('headers.pendings'),
        value: 'pendingCount'
      },
      {
        sortable: false,
        text: i18n.t('headers.pending-reason'),
        value: 'pendingReason'
      },
      {
        sortable: false,
        text: 'ALERTA',
        value: 'pendingReason'
      }
    ],
    patients: [],
    UserScheduling: '',
    isFeatured: false,
    items: [],
    orderType: '',
    orderNumber: '',
    showGrid: true,
    generationDate: new Date(),
    slidingScaleFee: '',
    shippingFee: '',
    documentCount: 0,
    orderDetails: [],
    pendingReasonItems: [],
    money: {
      decimal: ',',
      thousands: '',
      precision: 0,
      masked: false
    },
    disableButton: {
      type: Boolean,
      default: () => false
    },
    providerId: null,
    integratedProvider: 0,
    isProviderPresent: false,
    disableSaveButton: false,
    barcodes: [],
    providerBarcodes: [],
    barcode: '',
    invoiceBarCode: '',
    stickerData: {},
    isStickerRecently: false,
    userData: null,
    cancelEditing: false,
    orderId: null,
    showInvoice: true,
    invoices: [],
    filterData: '',
    dispatches: [],
    dispatchesToSave: [],
    zpl: '',
    prueba: '',
    disablePrint: false,
    providerList: [],
    prueba: '',
    quantityPending: 0,
    prueba: 0,
    barcodesByProvider: {},
    alreadyCheckIn: false,
    showBarcodeModal: false,
    dialogBarcode: false,
    selected: "",
    barcodesToShow: [],
    documentCountByProvider: 0
  }),

  directives: { money: VMoney },

  created() {
    this.getPendingReason()
    this.userData = StorageService.getUserData()
    this.providerId = this.userData.providerId
      ? this.userData.providerId
      : null
    this.integratedProvider = StorageService.getIntegratedProvider()
    this.isProviderPresent =
      this.providerId !== null && this.providerId !== this.integratedProvider

    const me = this
    window.addEventListener('beforeunload', function (event) {
      me.enableOrderEditing()
    })
  },
  computed: {
    ...mapState('auth', ['userInfo']),
    getHeader() {
      return this.headers
    },
    sumTotal() {
      return this.slidingScaleFee
    }

  },
  watch: {
    async showGrid() {
      // console.log(this.providerId)
      await this.enableOrderEditing()
    },
    selected: { 
      handler(selectedValue) {
        this.barcodesToShow = this.barcodesByProvider[this.selected.id];
        this.documentCountByProvider = this.barcodesByProvider[this.selected.id].length;
      },
      deep: true
    }
  },

  methods: {
    async getUserId() {
      let userId = await StorageService.getUserData().id;
      if (!userId || typeof userId === 'string') {
        if (this.userInfo) {
          userId = this.userInfo.id
        }
        userId = 0
      }
      return userId
    },

    async getProviderIds(orderDetails) {
      let providerIds = []
      orderDetails.map(orderDetail => {
        providerIds.push(orderDetail.providerId)
      })
      return providerIds;
    },

    async handleOrder(order, shippingFee, slidingScaleFee, invoice) {
      try {
        let response = await serviceOrder.getOrderWithId(order.id, false)
        order = response.data
        let date = new Date(order.generationDate)
        let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
        let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date)
        let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
        this.generationDate = `${ye}-${mo}-${da}`
        // if (invoice) {
        //   try {
        //     let response = await CheckInOrderService.getQuantities(
        //       { facturaNumber: invoice }
        //     )
        //     this.dispatches = response.data
        //   } catch (error) {
        //     this.$notify({
        //       group: 'app',
        //       type: 'error',
        //       text: 'Error consultando las cantidades facturadas'
        //     })
        //   }
        // } else {
        //   try {
        //     let response = await CheckInOrderService.getQuantitiesNoInvoice(
        //       { id: order.id }
        //     )
        //     this.dispatches = response.data
        //   } catch (error) {
        //     this.$notify({
        //       group: 'app',
        //       type: 'error',
        //       text: 'Error consultando las cantidades facturadas'
        //     })
        //   }
        // }

        let orderSlidingScaleFee = 0
        for (let i = 0; i < order.orderDetails.length; i++) {
          if (order.orderDetails[i].status != 'CANCELED' || order.orderDetails[i].status != 'RETURNED') {
            orderSlidingScaleFee += order.orderDetails[i].slidingScaleFee
          }
        }
        if (this.dispatches.length > 0) {
          try {
            for (let j = 0; j < order.orderDetails.length; j++) {
              const od = order.orderDetails[j]
              let filteredDispatches = this.dispatches.filter(dispatch => {
                return dispatch.order === od.code
              })
              if (filteredDispatches.length > 0) {
                for (let i = 0; i < od.orderDetailMedicines.length; i++) {
                  const medicine = od.orderDetailMedicines[i]
                  let auxMedicine
                  let auxDispatch = []
                  for (let k = 0; k < filteredDispatches.length; k++) {
                    let medicinesObject = filteredDispatches[k].medicines
                    for (let m = 0; m < medicinesObject.length; m++) {
                      const med = medicinesObject[m];
                      if (medicine.pluCode === med.cdSura) {
                        auxDispatch.push(filteredDispatches[k])
                      }
                    }
                  }
                  auxDispatch = auxDispatch.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
                  if (auxDispatch.length > 0) {
                    this.dispatchesToSave.push(auxDispatch[0])
                    let medicinesObject = auxDispatch[0].medicines
                    for (let m = 0; m < medicinesObject.length; m++) {
                      const med = medicinesObject[m]
                      if (medicine.pluCode === med.cdSura) {
                        auxMedicine = med
                        order.orderDetails[j].orderDetailMedicines[i].deliveredQuantity = auxMedicine.nmCantidadEntregaAcum || 0
                        order.orderDetails[j].orderDetailMedicines[i].invoice = auxDispatch[0].invoice || ''
                        order.orderDetails[j].orderDetailMedicines[i].idPendingReason = auxMedicine.cdMotivoEntregaParcial || ''
                      }
                    }
                  }
                  if (auxMedicine === undefined) {
                    this.$notify({
                      group: 'app',
                      type: 'error',
                      text: `No se ha encontrado facturas relacionadas con el medicamento de plu ${medicine.pluCode} en la orden ${od.code}`
                    })
                  }
                }
              } else {
                this.$notify({
                  group: 'app',
                  type: 'error',
                  text: `No se ha encontrado facturas relacionadas con la orden ${od.code}`
                })
              }

              let filteredDispatches2 = this.dispatchesToSave.filter(dispatch => {
                return dispatch.order === od.code
              })

              if (filteredDispatches2.length > 0) {
                order.orderDetails[j].slidingScaleFee = filteredDispatches2.reduce((a, b) => a + b.value, 0)
              }
            }
          } catch (error) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: 'Error procesando información de facturas'
            })
          }
        }
        let responseAlreadyCheckIn = await CheckInOrderService.alreadyCheckIn({ orderId: order.id })
        this.alreadyCheckIn = responseAlreadyCheckIn.data
        this.showGrid = !this.showGrid
        this.orderId = order.id
        this.order = order
        if (this.providerId !== 2) {
          this.showInvoice = false
          this.headers.splice(3, 1)
        }
        let aux = []
        for (const od of order.orderDetails) {
          if (!aux.includes(od.initialProvider.id)) {
            aux.push(od.initialProvider.id)
            this.providerList.push({ id: od.initialProvider.id, name: od.initialProvider.name })
          }
        }
        this.orderDetails = this.translateOrderDetailMedicines(
          order.orderDetails
        )
        this.shippingFee = shippingFee
        this.slidingScaleFee = Math.ceil(orderSlidingScaleFee)
        order.slidingScaleFee = Math.ceil(orderSlidingScaleFee)
        order.orderDetailBarCodes = order.orderDetailBarCodes || []
        // if (this.providerId === 8) {
        this.documentCount = order.orderDetailBarCodes.filter(
          odbc =>
            !this.isProviderPresent || odbc.idProvider.id === this.providerId
        ).length
        // } else {
        //   this.documentCount = order.orderDetailBarCodes.filter(
        //     odbc =>
        //       !this.isProviderPresent || odbc.initialProvider.id === this.providerId
        //   ).length
        // }
        this.barcodesByProvider = {}
        this.barcodes = []
        for (let provider of this.providerList) {
          this.barcodesByProvider[provider.id] = order.orderDetailBarCodes.map(barcode => {
            if (!this.barcodes.includes(barcode.barCode)) {
              this.barcodes.push(barcode.barCode)
            }
            if (barcode.initialProvider) {
              if (barcode.initialProvider.id === provider.id) {
                return barcode.barCode
              }
            }
          })
          this.barcodesByProvider[provider.id] = this.barcodesByProvider[provider.id].filter(barcode => barcode !== undefined)
        }
        this.providerBarcodes = this.barcodesByProvider
        this.showBarcodeModal = true
        this.patients = order.orderPatients.map(op => op.idPatient)
        // console.log('name: ', order.idUserScheduling)
        if (order.idUserScheduling === null) {
          this.UserScheduling = ''
        } else {
          this.UserScheduling = order.idUserScheduling.name
        }
        let userId = await this.getUserId();
        let data = {
          orderId: order.id,
          providerId: this.providerId ? this.providerId : 1,
          userId: userId
        }
        await OrderEditionService.registerOrderEdition(data)
      } catch (error) {
        console.log(error)
        if (error.code && error.code === 'ORDER_IS_ALREADY_EDITING') {
          this.cancelCheckIn()
          this.cancelEditing = true

          this.$notify({
            group: 'app',
            type: 'error',
            text: i18n.t('app.general.order-is-already-in-use')
          })
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: error
          })
        }
      }
    },
    initScan() {
      this.selected = this.providerList[0]
      window.addEventListener("keydown", (e) => {
        if (e.keyCode === 187) {
          e.preventDefault();
          return;
        }
      });
      this.dialogBarcode = true;
      this.$barcodeScanner.init(this.onBarcodeScanned);
    },
    onBarcodeScanned(barcode) {
      if (barcode === "Enter") {
        return;
      }

      const regex = /'/i;
      barcode = barcode.replace(regex, '-')

      if (!this.barcodes.includes(barcode)) {
        this.barcodes.push(barcode)
        this.barcodesByProvider[this.selected.id].unshift(barcode);
        this.barcodesToShow = this.barcodesByProvider[this.selected.id];
        this.documentCountByProvider = this.barcodesByProvider[this.selected.id].length;
        this.documentCount++;
        this.$forceUpdate();
      } else {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("scan-component.barcode-scanned-already"),
        });
      }
    },
    emitBarcodes() {
      this.$barcodeScanner.destroy();
      this.providerCode();
      this.dialogBarcode = false;
    },
    maxNumberOfField() {
      this.orderDetails.forEach(order => {

        if (order.deliveredCount > order.quantity) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'El numero de la cantidad entregada no debe ser superior al de la cantidad.'
          })
        }
      });
    },
    async save() {
      try {
        this.disableSaveButton = true
        if (this.documentCount && this.documentCount > 0) {
          if (this.areMedicineValid()) {
            // Bypass check in
            // await this.doCheckIn();
            this.generateSticker()
          }
        } else {
          throw i18n.t('check-in.order-must-have-one-barcode')
        }
      } catch (error) {
        this.disableSaveButton = false
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }
    },

    areMedicineValid() {
      this.orderDetails.forEach(medicine => {
        if (medicine.enablePendingReason) {
          if (!medicine.pendingReason) {
            // eslint-disable-next-line no-throw-literal
            throw `${i18n.t('check-in.reason-for-medicine-with-plu')} ${medicine.plu}!`
          }
        }
      })
      return true
    },

    async doCheckIn() {
      try {
        let data = {}
        let medicinesAux = []
        for (const od of this.orderDetails) {
          for (const medicine of od.medicines) {
            if (medicine.enablePendingReason) {
              if (!medicine.pendingReason) {
                // eslint-disable-next-line no-throw-literal
                this.disablePrint = false
                this.$notify({
                  group: 'app',
                  type: 'error',
                  text: `${i18n.t('check-in.reason-for-medicine-with-plu')} ${medicine.plu}!`
                })
                return false
              }
            }
            medicinesAux.push({
              id: medicine.id,
              deliveredCount: medicine.deliveredCount
                ? parseInt(medicine.deliveredCount)
                : 0,
              count: medicine.quantity,
              pendingCount: medicine.pendingCount,
              pendingReasonId: !medicine.enablePendingReason
                ? null
                : medicine.pendingReason,
              providerId: od.providerId
            })
          }
        }
        // let medicinesAux = this.orderDetails.map(medicine => {
        //   if (medicine.enablePendingReason) {
        //     if (!medicine.pendingReason) {
        //       // eslint-disable-next-line no-throw-literal
        //       this.disablePrint = false
        //       throw `${i18n.t('check-in.reason-for-medicine-with-plu')} ${medicine.plu}!`
        //     }
        //   }
        //   return {
        //     id: medicine.id,
        //     deliveredCount: medicine.deliveredCount
        //       ? parseInt(medicine.deliveredCount)
        //       : 0,
        //     pendingCount: medicine.pendingCount,
        //     pendingReasonId: !medicine.enablePendingReason
        //       ? null
        //       : medicine.pendingReason
        //   }
        // })
        for (const provider of this.providerList) {
          if (!this.providerBarcodes[provider.id]) {
            this.disablePrint = false
            this.$notify({
              group: 'app',
              type: 'error',
              text: `Se ha detectado un error leyendo los códigos de barra para el prestador ${provider.name}!`
            })
            return false
          }
          if (this.providerBarcodes[provider.id].length === 0 &&
            medicinesAux.filter(m => m.providerId === provider.id).every(m => m.deliveredCount === m.count)) {
            this.disablePrint = false
            this.$notify({
              group: 'app',
              type: 'error',
              text: `No se han leído códigos de barra para el prestador ${provider.name}!`
            })
            return false
          }
        }
        if (this.shippingFee === '' || this.shippingFee === undefined || this.shippingFee === null) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: `El valor de envío no puede estar vacío`
          })
          return false
        }
        let ShippingFeeAuthorization = this.orderDetails.map(element => {
          return {
            id: element.id,
            code: element.orderCode,
            shipping: element.slidingScaleFee
          }
        })
        let userId = await this.getUserId();
        // let provider = [3,4,4]
        // let providerIds = provider.filter( this.getProviderIds() )
        // console.log('this.providerId', this.providerId)
        let providerIds = await this.getProviderIds(this.orderDetails);
        data = {
          orderId: this.order.id,
          oldSlidingScaleFee: parseFloat(
            ('' + this.slidingScaleFee).split(',').join('')
          ),
          slidingScaleFee: parseFloat(('' + this.slidingScaleFee.split(',').join(''))),
          shippingFee: this.shippingFee,
          documentCount: this.documentCount,
          authorizations: ShippingFeeAuthorization,
          medicines: medicinesAux,
          providerCode: this.providerBarcodes,
          providerId: this.providerId,
          userId: userId,
          providerIds: providerIds,
          dispatches: this.dispatchesToSave
        }

        const result = await CheckInOrderService.doCheckIn(data)

        this.disableSaveButton = false
        this.disablePrint = false
        if (result && result.data) {
          this.showGrid = true
          this.$refs.orderList.getOrders();
          this.$notify({
            group: 'app',
            type: 'success',
            text: i18n.t('check-in.check-in-success')
          })
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: i18n.t('check-in.check-in-failed')
          })
        }
        return true
      } catch (error) {
        this.disableSaveButton = false
        this.disablePrint = false
        console.log(error)
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Ha ocurrido un error procesando el pedido. Intente de nuevo'
        })
        return false
      }
    },

    generateSticker() {
      let data = {
        orderId: this.order.id,
        providerId: this.providerId
      }

      CheckInOrderService.generateSticker(data)
        .then(result => {
          const data = result.data
          this.barcode = result.data.barCode
          this.stickerData = {
            patientName: this.order.idPatient.name,
            address: this.order.shippingAddress,
            city: this.order.idCity.name,
            cellphone: this.order.idPatient.mobilePhone,
            phone: this.order.idPatient.phone,
            scaleFee: this.order.slidingScaleFee
              ? this.order.slidingScaleFee
              : '0',
            shippingFee: this.shippingFee ? this.shippingFee : '0',
            consecutive: data.consecutive,
            observation: this.order.observation,
            total: parseInt(this.order.slidingScaleFee) + parseInt(this.shippingFee),
            scheduleRange: this.getScheduleRange(this.order.idProviderScheduleRange)
          }

          this.disableSaveButton = false
          this.isStickerRecently = data.recently

          this.$refs.barcodePrinter.sendDataToPrinter(
            this.stickerData,
            this.barcode
          )
        })
        .catch(() => {
          this.disableSaveButton = false
        })
    },

    getScheduleRange(providerScheduleRangeData) {
      let range = providerScheduleRangeData.idScheduleRange
      return range ? range.start.concat(' - ').concat(range.end) : ''
    },
    translateOrderDetailMedicines(orderDetail) {

      let slidingScaleFee = 0
      let dataOrderDetail = []
      if (this.providerId !== 8) {
        dataOrderDetail = orderDetail.filter(
          item =>
            !this.isProviderPresent || item.idProvider.id === this.providerId
        )
      } else {
        dataOrderDetail = orderDetail
      }

      dataOrderDetail = dataOrderDetail.map(od => {
        return {
          id: od.id,
          providerId: od.initialProvider.id,
          provider: od.initialProvider.name,
          orderCode: od.code,
          status: od.status,
          slidingScaleFee: od.slidingScaleFee,
          medicines: od.orderDetailMedicines.map(medicine => {
            return {
              id: medicine.id,
              plu: medicine.pluCode,
              description: medicine.description,
              invoice: medicine.invoice
                ? medicine.invoice
                : '',
              quantity: parseInt(medicine.quantity),
              deliveredCount: this.alreadyCheckIn ? parseInt(medicine.deliveredQuantity) : parseInt(medicine.quantity),
              pendingCount:
                parseInt(medicine.quantity) -
                parseInt(medicine.deliveredQuantity),
              pendingReason: medicine.idPendingReason
                ? medicine.idPendingReason
                : '',
              enablePendingReason: this.alreadyCheckIn
                ? parseInt(medicine.deliveredQuantity) !==
                  parseInt(medicine.quantity)
                : false
            }
          })
        }
      })

      for (const od of dataOrderDetail) {
        if (od.medicines.some(medicine => medicine.deliveredCount > 0)) {
          slidingScaleFee += +od.slidingScaleFee
        }
      }

      // medicines = medicines
      //   .map(item => {
      //     let orderCode = item.code
      //     let medicines = item.orderDetailMedicines.map(medicine => {
      //       this.isFeatured =
      //         this.isFeatured ||
      //         (medicine.idMedicineCondition
      //           ? medicine.idMedicineCondition.isFeatured
      //           : false)
      //       return {
      //         id: medicine.id,
      //         providerId: item.idProvider.id,
      //         provider: item.idProvider.name,
      //         orderCode,
      //         plu: medicine.pluCode,
      //         description: medicine.description,
      //         invoice: medicine.invoice
      //           ? medicine.invoice
      //           : '',
      //         quantity: parseInt(medicine.quantity),
      //         deliveredCount: parseInt(medicine.deliveredQuantity),
      //         pendingCount:
      //           parseInt(medicine.quantity) -
      //           parseInt(medicine.deliveredQuantity),
      //         pendingReason: medicine.idPendingReason
      //           ? medicine.idPendingReason
      //           : '',
      //         enablePendingReason:
      //           parseInt(medicine.deliveredQuantity) !==
      //           parseInt(medicine.quantity),
      //         status: item.status,
      //         slidingScaleFee: item.slidingScaleFee
      //       }
      //     })

      //     if (medicines.some(medicine => medicine.deliveredCount > 0)) {
      //       slidingScaleFee += +item.slidingScaleFee
      //     }

      //     return medicines
      //   })
      this.slidingScaleFee = Math.round(slidingScaleFee)
      this.order.slidingScaleFee = Math.round(slidingScaleFee)
      // return [].concat(...medicines)
      return dataOrderDetail
    },
    sumSliding(orderDetails) {
      let sum = 0;
      orderDetails.forEach(Element => {
        sum += parseInt(Element.slidingScaleFee);
      });
      this.$refs.slidingScaleFee.$el.getElementsByTagName('input')[0].value = sum
      this.slidingScaleFee = sum
    },
    cancelCheckIn() {
      this.showGrid = !this.showGrid
      this.isFeatured = false
      this.order = {}
      this.orderDetails = []
      this.slidingScaleFee = 0
      this.shippingFee = 0
      this.documentCount = 0
      this.disablePrint = false
      this.providerList = []
    },
    getValidDeliveredCount(a, b) {
      return a <= b ? a : b
    },
    getPendingReason() {
      pendingReasonsService.getPendings().then(response => {
        this.pendingReasonItems = response.data
      })
    },
    getPendingReasonName(id) {
      let pendingReasonItem = this.pendingReasonItems.find(
        item => item.id === id
      )
      return pendingReasonItem ? pendingReasonItem.name : ''
    },
    handleBarcodes(barcodes) {
      this.documentCount = barcodes.length
      this.barcodes = barcodes
      // this.barcodes.push(barcodes)
      // for (let i = 0; i < barcodes.length; i++) {
      //   if (!this.barcodes.includes(barcodes[i])) {
      //     this.barcodes.push(barcodes[i]);
      //   }
      // }
      // this.barcodes.push(barcodes)
    },
    providerCode(data) {
      this.providerBarcodes = this.barcodesByProvider
      let sum = 0
      for (const provider of this.providerList) {
        sum += this.providerBarcodes[provider.id].length
      }
      this.documentCount = sum
      // console.log('providerBarcode: ', this.providerBarcodes)
    },
    print() {
      if (this.isStickerRecently) {
        this.doCheckIn()
      }
      this.stickerData = {}
      this.barCode = ''
    },
    validationAfterChangeQuantity(medicine) {
      // for (let i = 0; i < this.orderDetails.length; i++) {
      //   const od = this.orderDetails[i]
      //   if (od.medicines.every(med => +med.deliveredCount === 0)) {
      //     this.orderDetails[i].slidingScaleFee = 0
      //   }
      // }
      this.updateEnablePendingReason(medicine)
    },
    updateEnablePendingReason(medicine) {
      medicine.deliveredCount =
        medicine.deliveredCount > -1 ? medicine.deliveredCount : 0

      medicine.deliveredCount =
        medicine.deliveredCount > medicine.quantity
          ? medicine.quantity
          : medicine.deliveredCount
      medicine.enablePendingReason =
        medicine.quantity - medicine.deliveredCount !== 0

      if (parseInt(medicine.deliveredCount) === medicine.quantity) {
        medicine.pendingReason = ''
      }

      this.updateSlidingScaleFee()
    },
    async validatedPrinter() {
      try {
        this.disablePrint = true
        let invoicesNumberOne = [...new Set(this.invoicesNumber)]
        if (invoicesNumberOne.length < this.invoices.length) {
          let invoiceMissing = this.invoices.find(i => i != invoicesNumberOne)
          this.$notify({
            group: 'app',
            type: 'error',
            text: `Faltan la factura ${invoiceMissing} por pistolear`
          })
          this.disablePrint = false
          return
        }
        this.disableSaveButton = true
        if (this.documentCount && this.documentCount > 0) {
          if (this.areMedicineValid()) {
            // Bypass check in
            let processed = await this.doCheckIn();

            if (processed) {
              this.printNow()
            }
          }
        } else {
          this.disablePrint = false
          throw i18n.t('check-in.order-must-have-one-barcode')
        }
        this.disablePrint = false
      } catch (error) {
        this.disablePrint = false
        this.disableSaveButton = false
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }

      //   let cantOrderDetail = this.orderDetails.length

      //   if (this.documentCount < cantOrderDetail) {
      //     console.log('no puede imprimir')
      //     this.$notify({
      //       group: 'app',
      //       type: 'error',
      //       text: 'no puede imprimir'
      //     })
      //   } else if (this.documentCount > cantOrderDetail) {
      //     console.log('pistoleo mas de los que debia')
      //     this.$notify({
      //       group: 'app',
      //       type: 'error',
      //       text: 'Pistoleo mas de lo que debia'
      //     })
      //   }
    },

    printNow() {
      let data = {
        orderId: this.order.id,
        providerId: this.providerId
      }

      CheckInOrderService.generateSticker(data)
        .then(result => {
          const data = result.data
          this.barcode = result.data.barCode
          // this.barcode = data.barCode
          // this.stickerData = {
          //   patientName: this.order.idPatient.name,
          //   address: this.order.shippingAddress,
          //   city: this.order.idCity.name,
          //   cellphone: this.order.idPatient.mobilePhone,
          //   phone: this.order.idPatient.phone,
          //   scaleFee: this.order.slidingScaleFee
          //     ? this.order.slidingScaleFee
          //     : '0',
          //   shippingFee: this.order.shippingFee ? this.order.shippingFee : '0',
          //   consecutive: data.consecutive,
          //   observation: this.order.observation,
          //   total: parseInt(this.order.slidingScaleFee) + parseInt(this.order.shippingFee),
          //   scheduleRange: this.getScheduleRange(this.order.idProviderScheduleRange)

          // }

          this.disableSaveButton = false
          this.isStickerRecently = data.recently

          // this.pruebaPrint(send(this.stickerData, this.barcode))
          // this.previewData(send(this.stickerData, this.barcode))
          this.previewData(data)
          // this.doCheckIn()
        })
        .catch(() => {
          this.disableSaveButton = false
        })
    },
    myDialogClose() {
      this.myDialogVisible = false
      // other code
    },
    async previewData(data) {
      // let info = {
      //   id: this.userData.id,
      //   zpl: data
      // }
      this.providerList = []
      let info = {
        scaleFee: this.order.slidingScaleFee
          ? this.order.slidingScaleFee
          : '0',
        shippingFee: this.shippingFee,
        quantity: data.consecutive,
        patientName: this.order.idPatient.name,
        city: this.order.idCity.name,
        scheduleRange: this.getScheduleRange(this.order.idProviderScheduleRange),
        address: this.order.shippingAddress,
        phone: `${this.order.idPatient.phone} - ${this.order.idPatient.mobilePhone}`,
        observation: this.order.observation,
        barcodeText: data.barCode,
        order: this.order
      }
      printerPreviewService.savePDF(info)
        .then(response => {
          // const file = new Blob(
          //   [response.data],
          //   {type: 'application/pdf'});
          //Build a URL from the file
          // const fileURL = window.URL.createObjectURL(response.data);
          // //Open the URL on new Window
          // let w = window.open(fileURL);
          // w.focus()
          // w.print()

          // let fileName = "sticker.pdf";
          // let a = document.createElement("a");
          // document.body.appendChild(a);
          // a.style = "display: none";
          // let file = new Blob([response.data], {type: 'application/pdf'});
          let fileURL = window.URL.createObjectURL(response.data);
          document.querySelector('#pdf').src = '';
          document.querySelector('#pdf').src = fileURL;
          // console.log(window.frames)
          // document.getElementById("pdf").contentWindow.print();
          // fileURL = URL.revokeObjectURL(response.data);
          // let iFrameBody = this.$refs.pdf
          // console.log(iFrameBody)
          // iFrameBody.print()
          // let frm = document.getElementById('pdf').contentWindow;
          // document.getElementById('pdf').contentWindow.print()
          // console.log(frm)
          // frm.focus();
          // frm.print();
          window.setTimeout(function () {
            window.frames["pdf"].focus();
            window.frames["pdf"].print();
            //   document.querySelector('#pdf-frame').contentWindow.print();
          }, 1000)
          // a.href = fileURL;
          // a.download = fileName;
          // a.click();

          // this.getUploadPDF()
          // this.doCheckIn()
        })
        .catch(error => {
          this.$notify({
            group: 'app',
            type: 'error',
            text: error // i18n.t(error)
          })
        })
    },

    getUploadPDF() {
      let url = this.viewPrint + this.userData.id + '/label.pdf'
      // console.log(pdfUrl);
      var w = window.open(url)
      w.focus()
      w.print()
    },

    pruebaPrint(data) {
      let code = encodeURIComponent(data)
      let ZPL = `http://api.labelary.com/v1/printers/8dpmm/labels/4x2/0/${code}`

      var proxyIframe = document.createElement('iframe')
      var body = document.getElementsByTagName('body')[0]
      body.appendChild(proxyIframe)
      // proxyIframe.style.width = '100%'
      // proxyIframe.style.height = '100%'
      proxyIframe.style.display = 'none'

      // Set dimensions according to your needs.
      // You may need to calculate the dynamically after the content has loaded width="800" height=365"
      let content = proxyIframe.contentWindow
      content.document.write(`<iframe src=${ZPL} type="application/pdf" onload="print();" width="800" height=365" frameborder="0" marginheight="0" marginwidth="0"></iframe>`)
      content.document.focus()
      content.focus()
    },
    onlyNumber(e) {
      // Si el código es menor que 48 (0) o mayor que 57 (9)
      // if (e.keyCode < 48 || e.keyCode > 57) {
      //   // No se agrega
      //   e.preventDefault();
      // }
      const key = e.key;
      if (key === '.' || key === '-')
        return e.preventDefault();
    },
    updateSlidingScaleFee() {
      let slidingScaleFee = 0

      // const distinctOrderCodes = [...new Set(this.orderDetails.map(x => x.orderCode))]

      for (const od of this.orderDetails) {
        // if (od.medicines.some(medicine => +medicine.deliveredCount > 0)) {
          slidingScaleFee += +od.slidingScaleFee
        // }
      }

      // distinctOrderCodes.forEach(orderCode => {
      //   const medicines = this.orderDetails.filter(od => od.orderCode === orderCode)
      //   if (medicines.some(medicine => +medicine.deliveredCount > 0)) {
      //     slidingScaleFee += +medicines[0].slidingScaleFee
      //   }
      // })

      this.$refs.slidingScaleFee.$el.getElementsByTagName('input')[0].value = slidingScaleFee
      this.slidingScaleFee = slidingScaleFee

      // this.$refs.anotherSlidingScaleFee.$el.getElementsByTagName('input')[0].value = slidingScaleFee
      this.order.slidingScaleFee = slidingScaleFee
    },

    async enableOrderEditing() {
      if (!this.cancelEditing && this.orderId) {
        try {
          let userId = await this.getUserId();
          let data = {
            orderId: this.orderId,
            providerId: this.providerId,
            userId: userId
          }

          await OrderEditionService.enableOrderEdition(data)
        } catch (error) { }
      }

      this.cancelEditing = false
    }
  },

  beforeDestroy() {
    this.providerList = []
    this.enableOrderEditing()
  }
}
